import { useTranslation } from "react-i18next";
import deactivate from "shared/assets/images/deactivate.png";
import { NAME_SPACES } from "shared/locales/constants";
import { useApolloClient } from "@apollo/client";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import { StoreContext } from "shared/store";

const NotAuthorized = () => {
  const { t } = useTranslation(NAME_SPACES.AUTH);
  const NOT_AUTHORIZED = t("NOT_AUTHORIZED", {
    returnObjects: true,
  });
  const { clearStore } = useContext(StoreContext);
  const client = useApolloClient();
  const logout = async () => {
    await client.clearStore();
    await client.resetStore();
    clearStore();
  };
  useEffect(() => {
    logout();
  }, []);
  return (
    <div className="auth">
      <img src={deactivate} alt="deactivate" />
      <h3 className="auth__deactivate--title">{NOT_AUTHORIZED.TITLE}</h3>
      <p className="auth__deactivate--text">{NOT_AUTHORIZED.TEXT}</p>
    </div>
  );
};

export default NotAuthorized;
